import {WebStorage} from './Storage';
import {IStorage} from './IStorage';

export function useStorage(): IStorage {
  return WebStorage();
}
